<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import EmailTriageAPI from 'dashboard/api/emailTriage';
import types from 'dashboard/store/mutation-types';
import Button from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

// RedHosting: e-mail que passou pelo filtro mas nao e atendimento. Bloqueia o
// remetente e manda o e-mail para a aba Nao e atendimento.
const props = defineProps({
  conversationId: { type: Number, required: true },
});

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const dialogRef = ref(null);
const isMarking = ref(false);

const markNotSupport = async () => {
  isMarking.value = true;
  try {
    await EmailTriageAPI.markNotSupport(props.conversationId);
    dialogRef.value.close();
    store.commit(types.DELETE_CONVERSATION, props.conversationId);
    useAlert(t('EMAIL_TRIAGE.MARKED'));
    router.push({ name: 'home' });
  } catch (error) {
    useAlert(t('EMAIL_TRIAGE.MARK_ERROR'));
  } finally {
    isMarking.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col gap-2 px-4 py-3 border-b border-n-weak">
    <p class="m-0 text-xs text-n-slate-11">
      {{ t('EMAIL_TRIAGE.PANEL_HINT') }}
    </p>
    <Button
      :label="t('EMAIL_TRIAGE.MARK')"
      icon="i-lucide-mail-x"
      slate
      faded
      xs
      class="self-start"
      @click="dialogRef.open()"
    />
    <Dialog
      ref="dialogRef"
      type="alert"
      :title="t('EMAIL_TRIAGE.MARK_TITLE')"
      :description="t('EMAIL_TRIAGE.MARK_DESCRIPTION')"
      :confirm-button-label="t('EMAIL_TRIAGE.MARK_CONFIRM')"
      :is-loading="isMarking"
      @confirm="markNotSupport"
    />
  </div>
</template>
